import { render, staticRenderFns } from "./Cow.vue?vue&type=template&id=2a333792&scoped=true"
var script = {}
import style0 from "./Cow.vue?vue&type=style&index=0&id=2a333792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a333792",
  null
  
)

export default component.exports